import { Box, Skeleton } from '@mui/material'

const ROW_HEIGHT = 32
const INDENT_PATTERN = [0, 0, 1, 1, 2, 1, 0, 1]

/** Mimics tree structure with indented rows for loading state; fills full height */
export const TreeSkeleton = () => (
	<Box
		data-testid="tree-v2-skeleton"
		sx={{
			px: 1,
			py: 0.5,
			height: '100%',
			display: 'flex',
			flexDirection: 'column',
			minHeight: 0,
		}}
	>
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				flex: 1,
				minHeight: 0,
				overflow: 'auto',
				'& > * + *': { mt: 0.5 },
			}}
		>
			{Array.from({ length: 50 }).map((_, i) => {
				const indent = INDENT_PATTERN[i % INDENT_PATTERN.length]
				const width = 100 - indent * 12
				return (
					<Box
						key={i}
						sx={{
							display: 'flex',
							alignItems: 'center',
							height: ROW_HEIGHT,
							flexShrink: 0,
							pl: indent * 2,
						}}
					>
						<Skeleton
							variant="rounded"
							width={16}
							height={16}
							sx={{ flexShrink: 0, mr: 1 }}
						/>
						<Skeleton
							variant="text"
							width={`${width}%`}
							height={20}
							sx={{ flex: 1, maxWidth: 220 }}
						/>
					</Box>
				)
			})}
		</Box>
	</Box>
)
